import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const saveSettings = async (payload: CMSSetting[]) => {
	const response = await cmsClient.patch<CMSSetting[]>("/settings/", payload);
	return response.data;
};

const useSaveSectionTitleSettings = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Section titles updated" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["section-title-settings"]);
	};

	return useMutation(saveSettings, { onSuccess, onError, onSettled });
};

export default useSaveSectionTitleSettings;
